import { Breadcrumb } from "antd";
import useQuery from "hooks/useQuery";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Link, UIMatch, useMatches } from "react-router-dom";
import { IBreadCrumbItem } from "shared/interface/types";

const CustomBreadCrumb = (): ReactElement => {
  const { params } = useQuery();
  const { tab: activeTab } = params as { tab: string };
  const { t } = useTranslation();
  const matches: UIMatch[] = useMatches();

  const breadcrumbRoutes = matches.find(matchRoute => Boolean((matchRoute?.handle as { crumbs: [] })?.crumbs));
  const currentRouteBreadcrumb = (breadcrumbRoutes?.handle as { crumbs: { title: string; link?: string }[] })?.crumbs;

  const currentRouteBreadcrumbItems = currentRouteBreadcrumb?.map(({ title, link }: IBreadCrumbItem) => {
    const translatedTitle = t(title);
    return { title: link ? <Link to={link || "."}>{translatedTitle}</Link> : translatedTitle };
  });

  if (activeTab) {
    currentRouteBreadcrumbItems?.push({ title: activeTab });
  }

  return currentRouteBreadcrumb && <Breadcrumb items={currentRouteBreadcrumbItems} />;
};

export default CustomBreadCrumb;
